export function FormDesignTab() {
    return <div>Form design</div>;
}
